export const environment = {
  production: true,
  version: '1.22.1',
  appConfigUrl: 'assets/config/app.config.json',
};
